import React, { useState } from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';

const DeleteRouteModal = ({ show, handleClose, routeId: selectedRoute, fetchRoutes, origin, destination, provider }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setIsDeleting(true);
    setError('');
    try {
      await axios.delete(`/api/routes/${selectedRoute ? selectedRoute.provider_guide_id : null}`);
      // Trigger search with current search field values
      fetchRoutes(origin, destination, provider);
      handleClose();
    } catch (err) {
      setError('Error deleting route. Please try again.');
      console.error('Error deleting route:', err);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Route</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        Are you sure you want to delete this route?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={isDeleting}>
          {isDeleting ? <Spinner as="span" animation="border" size="sm" /> : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRouteModal;
